<template>
    <EntityGrid
        title="Processes"
        :entities="processes"
        :is-editing="isEditing"
        add-button-label="Add process"
        @add="openNewProcess()"
    >
        <EntityCard
            v-for="process in processes"
            :key="process.identity"
            :entity="process"
            :entityType="EntityType.PROCESS"
            border-color="var(--stekz-primary-color)"
            :to="{
                name: 'processPage',
                params: {
                    orgName: route.params.orgName,
                    stekName: route.params.stekName,
                    processId: process.identity,
                },
            }"
        />
        <template #empty>
            <div class="empty-state">
                <i class="pi pi-sitemap empty-icon"></i>
                <div>
                    <h3>No products or services set</h3>
                    <i>
                        <p v-if="isEditing">Create your first process.</p>
                        <p v-else>
                            To add processes, go into edit mode from the top of
                            the page.
                        </p>
                    </i>
                </div>
                <Button
                    v-if="isEditing"
                    label="Add Process"
                    icon="pi pi-plus"
                    severity="primary"
                    @click="openNewProcess()"
                />
            </div>
        </template>
    </EntityGrid>
</template>

<script setup lang="ts">
import { useNewProcessDialog } from "@/composables/new-process-dialog";
import type { ProcessInTree } from "@/stores/processes-store";
import { useRoute } from "vue-router";
import EntityCard from "@/components/EntityInfo/EntityCard.vue";
import EntityGrid from "@/components/EntityInfo/EntityGrid.vue";
import { EntityType } from "@/stores/entity-store";

defineProps<{
    isEditing: boolean;
    processes: ProcessInTree[];
}>();

const route = useRoute();
const { open: openNewProcess } = useNewProcessDialog();
</script>

<style lang="scss" scoped>
.empty-state {
    display: flex;
    flex-direction: column;
    gap: 1em;
    align-items: center;
    text-align: center;

    > * {
        margin: 0;
    }

    .empty-icon {
        font-size: 3rem;
    }
}
</style>
